module.exports = __webpack_public_path__ + "static/lone-survivor-4edbf67d411f631d012f2ab7f636c0c0.jpg";